(function () {
  console.log('[GR Styles] Script loaded');

  var shadowRootMap = window.__grShadowRoots;

  var SVG_ARROW = '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_5710_1697)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537 0.807624C8.5684 0.731393 8.61816 0.664108 8.68186 0.611762C8.74555 0.559415 8.8212 0.523631 8.90207 0.507596C8.98294 0.49156 9.06652 0.495771 9.14537 0.519853C9.22422 0.543935 9.29589 0.587141 9.354 0.645624L13.354 4.64562C13.4006 4.69207 13.4375 4.74725 13.4627 4.80799C13.4879 4.86874 13.5009 4.93386 13.5009 4.99962C13.5009 5.06539 13.4879 5.13051 13.4627 5.19126C13.4375 5.252 13.4006 5.30718 13.354 5.35362L9.354 9.35362C9.26011 9.44751 9.13278 9.50026 9 9.50026C8.86722 9.50026 8.73989 9.44751 8.646 9.35362C8.55211 9.25974 8.49937 9.1324 8.49937 8.99962C8.49937 8.86685 8.55211 8.73951 8.646 8.64562L11.793 5.49962H1C0.867392 5.49962 0.740215 5.44695 0.646447 5.35318C0.552678 5.25941 0.5 5.13223 0.5 4.99962C0.5 4.86702 0.552678 4.73984 0.646447 4.64607C0.740215 4.5523 0.867392 4.49962 1 4.49962H11.793L8.646 1.35362C8.57575 1.28367 8.52788 1.19442 8.50847 1.0972C8.48906 0.999981 8.49899 0.899187 8.537 0.807624Z" fill="#2E2E2C"/></g><defs><clipPath id="clip0_5710_1697"><rect width="14" height="10" fill="white"/></clipPath></defs></svg>';

  var GR_STYLES = `
    input[type='text'],
    input[type='email'],
    input[type='number'],
    input[type='date'],
    .text_wrapper,
    .select_wrapper {
      box-shadow: none !important;
      border: none !important;
      border-bottom: 1px solid var(--Neutral-3, #C0C0C0) !important;
      border-radius: 0 !important;
      font-family: "figtree-regular", Arial, sans-serif !important;
    }

    input[type='radio'] + label .checkbox,
    input[type='checkbox'] + label .checkbox {
      box-shadow: none !important;
      border: 1px solid #2E2E2C !important;
    }

    .hHeVtn,
    .htuwKP,
    .hvJSbE,
    .cwTfTz,
    .cMxrfC,
    .hvJSbE input[type='radio'] + label,
    .hvJSbE input[type='checkbox'] + label {
      margin: 0 !important;
    }

    .hHeVtn,
    .htuwKP {
    width: 100% !important;
    }

    [data-gr-input-wrapper] {
      position: relative !important;
    }

    [data-gr-input-wrapper] input {
      padding-right: 48px !important;
    }

    [data-gr-inline-button] {
      position: absolute !important;
      right: 6px !important;
      top: 50% !important;
      transform: translateY(-50%) !important;
      background: transparent !important;
      border: none !important;
      border-radius: 0 !important;
      padding: 4px !important;
      cursor: pointer !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    [data-gr-inline-button]:hover svg path {
      fill: #797979 !important;
    }

    [data-gr-button-hidden] {
      display: none !important;
    }
    input:focus,
    input:focus-visible,
    a:focus,
    a:focus-visible,
    button:focus,
    button:focus-visible {
      outline: none !important;
      box-shadow: none !important;
    }
  `;

  function injectStylesIntoRoot(root) {
    if (root.__grStylesInjected) return;
    var style = document.createElement('style');
    style.textContent = GR_STYLES;
    root.appendChild(style);
    root.__grStylesInjected = true;
    console.log('[GR Styles] Styles injected');
  }

  function restructureForm(root) {
    var form = root.querySelector('form');
    console.log('[GR Styles] restructureForm — form found:', !!form, '| already done:', form && !!form.__grRestructured);
    if (!form || form.__grRestructured) return;

    var inputEl = root.querySelector('input[data-ats-form-field="email"]');
    var buttonEl = root.querySelector('button[type="submit"]');
    var buttonWrapperEl = root.querySelector('[data-ats-wb-element="button"]');
    console.log('[GR Styles] inputEl:', !!inputEl, '| buttonEl:', !!buttonEl, '| buttonWrapperEl:', !!buttonWrapperEl);

    if (!inputEl || !buttonEl) return;

    var inputWrapper = inputEl.parentElement;
    if (!inputWrapper) return;

    buttonEl.innerHTML = SVG_ARROW;
    buttonEl.setAttribute('data-gr-inline-button', '');
    inputWrapper.setAttribute('data-gr-input-wrapper', '');
    inputWrapper.appendChild(buttonEl);

    if (buttonWrapperEl && buttonWrapperEl.parentElement) {
      buttonWrapperEl.parentElement.setAttribute('data-gr-button-hidden', '');
    }

    form.__grRestructured = true;
    console.log('[GR Styles] Form restructured — button moved into input');
  }

  function watchShadowRoot(root) {
    if (root.__grWatching) return;
    root.__grWatching = true;
    new MutationObserver(function () {
      var btn = root.querySelector('button[type="submit"]');
      if (btn && !btn.hasAttribute('data-gr-inline-button')) {
        console.log('[GR Styles] GR reset the form — re-restructuring');
        var form = root.querySelector('form');
        if (form) form.__grRestructured = false;
        restructureForm(root);
      }
    }).observe(root, { childList: true, subtree: true });
  }

  function applyToElement(el) {
    if (!shadowRootMap) {
      console.warn('[GR Styles] shadowRootMap missing');
      return;
    }
    var root = shadowRootMap.get(el);
    console.log('[GR Styles] applyToElement — shadow root found:', !!root);
    if (!root) return;
    injectStylesIntoRoot(root);
    restructureForm(root);
    watchShadowRoot(root);
  }

  // Główna funkcja — uruchamiana po pełnej inicjalizacji GR
  function applyToAll() {
    console.log('[GR Styles] applyToAll called');
    document.querySelectorAll('getresponse-form').forEach(applyToElement);
  }

  // Czekamy aż GR zdefiniuje custom element, potem dajemy mu chwilę na render
  if (customElements) {
    customElements.whenDefined('getresponse-form').then(function () {
      console.log('[GR Styles] custom element defined — applying after rAF');
      requestAnimationFrame(function () {
        requestAnimationFrame(applyToAll);
      });
    });
  }

  // Fallback: obserwuj data-ready
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (
        mutation.type === 'attributes' &&
        mutation.target.tagName === 'GETRESPONSE-FORM'
      ) {
        console.log('[GR Styles] data-ready detected on', mutation.target);
        applyToElement(mutation.target);
      }
      for (var j = 0; j < mutation.addedNodes.length; j++) {
        var node = mutation.addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'GETRESPONSE-FORM') applyToElement(node);
        else node.querySelectorAll('getresponse-form').forEach(applyToElement);
      }
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-ready'],
  });

  // Ostatni fallback: po załadowaniu strony
  document.addEventListener('DOMContentLoaded', applyToAll);
})();
